import Loader from "./Loader";

function MainLoader() {
  return <Loader />;
}

export default MainLoader;
